import { Link, useSearchParams } from 'react-router-dom'
import { RegisterForm } from '@/components/auth/RegisterForm'
import { AuthLogo } from '@/components/auth/AuthLogo'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'
import { Box, Card, CardContent, Typography } from '@mui/material'
import '@/styles/auth.css'

/**
 * Параметр адреса с кодом приглашения.
 *
 * API собирает ссылку приглашения как `/register?code=…` — и ту, что учитель
 * копирует в диалоге, и ту, что уходит ученику в письме.
 */
const INVITATION_CODE_PARAM = 'code'

export function RegisterPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const invitationCode = searchParams.get(INVITATION_CODE_PARAM)?.trim() ?? ''

  return (
    <Box className="auth-page">
      <Box className="auth-language-switcher">
        <LanguageSwitcher />
      </Box>
      <Box className="auth-container register">
        <Card className="auth-card">
          <CardContent>
            <AuthLogo />

            <Typography variant="h1" component="h1" sx={{ textAlign: 'center', mb: 1 }}>
              {t('auth.registerTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
              {t('auth.registerSubtitle')}
            </Typography>

            <RegisterForm initialCode={invitationCode} />

            <Box className="auth-footer">
              <Typography variant="body2">
                {t('auth.haveAccount')}{' '}
                <Link to={ROUTES.LOGIN} className="auth-link">
                  {t('auth.login')}
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
